import { BCMSValidate } from "@bcm-dev/bcms-vite";
import { useEffect, useState } from "react";
import { SVGAsset } from "res";
import { UITextInput } from "..";

import "./styles.css";

export default function UINumberInput(props) {
    const point = props.dataPoint ?? "";
    const [ state, setState ] = useState({ "input" : props.value ?? "", "close" : false });

    const onChange = value => {
        const newValue = BCMSValidate.isNumber(value) || value === "" ? value : state.input;
        setState({ "input" : newValue, "close" : value.length > 0 });

        if(props.onChange instanceof Function) {
            props.onChange(newValue);
        }
    };

    const onBlur = value => props.onBlur instanceof Function
        ? props.onBlur(value)
        : undefined;

    const reset = evt => {
        setState({ "input": "", "close" : false });

        if(props.onChange instanceof Function) {
            props.onChange("");
        }
    };

    // Added useEffect to reset state when the props.value is either undefined or is an empty string
    useEffect(() => {
        const defaultState = { "input" : "", "close" : false };

        if((props.value === undefined || props.value === "") && state !== defaultState) {
            setState(defaultState);
        }
        else {
            setState({ "input" : props.value, "close" : true });
        }
    }, [ props.value ]);

    return (
        <div className="ui-number-input">
            <div className="flex-container flex-horizontal align-center">
                <UITextInput placeholder={ props.placeholder } value={ state.input } onChange={ onChange } onBlur={ onBlur } data-point={ point } />
                { state.close && <SVGAsset id="CloseX" className="icon clickable" onClick={ reset } /> }
            </div>
        </div>
    );
}